import {h, Fragment} from "preact"
import Pagination from './Pagination'

export default function BottomToolbar() {
    return <Pagination />
}
